import axios from 'axios'
import { wrapApiError } from '@/utils/apiError'

const API_URL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:8000'

// Normalize into the shared wrapApiError shape ({message, status, details,
// detail}) so callers can translate errors via translateApiError.
function normalizeError(error, fallbackMessage) {
  return wrapApiError(error, fallbackMessage, 'No response from server')
}

export const addonsApi = {
  /** Catalog + active add-ons + credit balances + purchase eligibility */
  async getAddons() {
    try {
      const response = await axios.get(`${API_URL}/subscriptions/addons`)
      return response.data
    } catch (error) {
      throw normalizeError(error, 'Failed to fetch add-ons')
    }
  },

  /** Purchase a recurring add-on (prorated first charge now) */
  async purchaseAddon(catalogKey, quantity = 1) {
    try {
      const response = await axios.post(`${API_URL}/subscriptions/addons`, {
        catalog_key: catalogKey,
        quantity
      })
      return response.data
    } catch (error) {
      throw normalizeError(error, 'Add-on purchase failed')
    }
  },

  /** Cancel an add-on - stays active until the next billing date */
  async cancelAddon(addonId) {
    try {
      const response = await axios.delete(`${API_URL}/subscriptions/addons/${addonId}`)
      return response.data
    } catch (error) {
      throw normalizeError(error, 'Failed to cancel add-on')
    }
  },

  /** One-time purchase of a consumable credit pack */
  async purchaseCreditPack(catalogKey) {
    try {
      const response = await axios.post(`${API_URL}/credits/purchase`, {
        catalog_key: catalogKey
      })
      return response.data
    } catch (error) {
      throw normalizeError(error, 'Credit pack purchase failed')
    }
  },

  async getCreditBalances() {
    try {
      const response = await axios.get(`${API_URL}/credits/balance`)
      return response.data
    } catch (error) {
      throw normalizeError(error, 'Failed to fetch credit balances')
    }
  }
}
